export function PenAndInkIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 8c-2 0-4 2-4 4v24c0 2 2 4 4 4" />
      <path d="M20 8c2 0 4 2 4 4v24c0 2-2 4-4 4" />
      <line x1="20" y1="36" x2="20" y2="42" />
      <circle cx="20" cy="43" r="1.5" fill="currentColor" />
      <path d="M30 14c0-3 2-6 4-6s4 3 4 6v18c0 3-2 6-4 6s-4-3-4-6z" />
      <line x1="30" y1="20" x2="38" y2="20" />
    </svg>
  );
}
